import axios from "axios"
import axiosInstance from "../Interceptor"

export const getActiveAdsApi = (payload) => {
	const basUrl = process.env.REACT_APP_BASE_URL_TWO;
 
	return axios
	.get(`${basUrl}users/api/v1/ads/?status=${payload}`)
		.then((res) => {
		 
			return res
		})
		.catch((err) => {
		 
			return err
		})
}